const GOOGLE_MAPS_URL = 'https://www.google.com/maps/search/?api=1';

export const getGoogleMapUrl = (address: string) => {
  return `${GOOGLE_MAPS_URL}&query=${encodeURIComponent(address)}`;
};
